<template>
  <v-container
    id="comercial-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-container>
          <dashboard-filtro-mais-vida
            :primeiro="enablePrimeiroDia"
            :ultimo="enableUltimoDia"
            :empresas="enableEmpresa"
            :url="link"
            :clientes="enableClientes"
            :cidades="enableCidades"
            :areas="enableAreas"
            :vendedores="enableVendedores"
            :redes="enableRedes"
            :produtos="enableProdutos"
            :linhas="enableLinhas"
            :btn1="enableBtn"
            :btn2="disableBtn"
            :enable-datas="enableDatas"
            :segmentos="enableSegmento"
          />
          <v-row>
            <v-col
              cols="12"
              sm="12"
              md="12"
              lg="12"
            >
              <v-card
                id="cardDashbord"
                class="mx-auto"
                outlined
              >
                <div class="card-header-dashbord">
                  <v-row>
                    <v-col
                      cols="12"
                      sm="10"
                      md="10"
                      lg="10"
                      class="d-flex flex-wrap"
                    >
                      Comparativo Volume x Preço Médio
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                      lg="2"
                      class="d-flex justify-end"
                    >
                      <v-tooltip
                        top
                        max-width="400"
                        width="400"
                      >
                        <template
                          v-slot:activator="{ on, attrs }"
                        >
                          <v-icon
                            id="iconInformationClientesParcipantes"
                            class="text-left"
                            v-bind="attrs"
                            v-on="on"
                            @mouseover="enableTexto('229')"
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <div
                          v-if="!carregandoTooltip"
                          v-html="textoOrientacao"
                        />
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-card-actions>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <dashboard-grafico-volume-perido />
                    </v-col>
                  </v-row>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import utils from '../../../../services/utils'
  import Permissao from '../../../../services/menu'
  import eventEmit from '../../components/core/EventoEmit'

  export default {
    name: 'PageMaisVida03',
    emits: ['updateFormMaisVida', 'atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../components/core/Snackbar'),
      DashboardFiltroMaisVida: () => import('../../components/core/FiltrosMaisVida'),
      DashboardGraficoVolumePerido: () => import('../../graficos/Comercial/EvolucaoFaturamentoVolume'),
    },
    mixins: [utils],
    data: () => ({
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      usuarioIdentificado: false,
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      metaMensal: 0,
      dataInicial: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      dataFinal: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      dateFormatted: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      select: [],
      empresa: [],
      link: window.location.href,
      cidades: [],
      areas: [],
      vendedores: [],
      redes: [],
      produtos: [],
      linhas: [],
      clientes: [],
      segmento: [],
      paginaEnable: true,
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      enableEmpresa: true,
      enableClientes: false,
      enableCidades: true,
      enableAreas: true,
      enableVendedores: true,
      enableRedes: true,
      enableProdutos: true,
      enableLinhas: true,
      enableBtn: true,
      disableBtn: false,
      enableDatas: true,
      enableSegmento: true,
      codigo: 0,
      orientacao: [],
      textoVolumePrecoMedio: '',
      codigoIds: ['229'],
      dynamicPaddingVolume: '',
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.date)
      },

      computedPrimeiroDia () {
        return this.formatDate(this.dataInicial)
      },
    },

    watch: {
      date (val) {
        this.dateFormatted = this.formatDate(this.dataFinal)
      },
    },

    created () {
      eventEmit.$on('update-dados-mais-vida', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-mais-vida', this.handleUpdateDados)

      window.removeEventListener('resize', this.updateDynamicPadding)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        eventEmit.$emit('atualizar_texto', 'Volume Preço')

        this.updateDynamicPadding()

        window.addEventListener('resize', this.updateDynamicPadding)

        this.usuarioIdentificado = true
      } else {
        this.usuarioIdentificado = false
        this.$router.push('/login')
      }
    },

    methods: {
      updateDynamicPadding () {
        if (window.innerWidth > 1800) {
          this.dynamicPaddingVolume = 'padding-right: 106rem !important'
        } else if (window.innerWidth > 1380 && window.innerWidth <= 1800) {
          this.dynamicPaddingVolume = 'padding-right: 85rem !important'
        } else if (window.innerWidth > 380 && window.innerWidth < 600) {
          this.dynamicPaddingVolume = 'padding-right: 11rem !important'
        } else if (window.innerWidth > 601 && window.innerWidth < 1000) {
          this.dynamicPaddingVolume = 'padding-right: 30rem !important'
        } else {
          this.dynamicPaddingVolume = 'padding-right: 63rem !important'
        }
      },

      handleUpdateDados (dataInicial, dataFinal, empresaSelect, cidadeSelect, areaSelect, redeSelect, vendedorSelect, produtoSelect, linhaSelect, clienteSelect, caixaSelect, selectTipoDevolucao, selectMotivoDevolucao, primeiroDia2, date2, select1, cidadeSelect1, areaSelect1, redeSelect1, vendedorSelect1, produtoSelect1, linhaSelect1, clienteSelect1, caixaSelect1, selectReceita, selectSegmento, selectSegmento1) {
        this.dataInicial = dataInicial
        this.dataFinal = dataFinal
        this.select = empresaSelect
        this.cidades = cidadeSelect
        this.areas = areaSelect
        this.redes = redeSelect
        this.vendedores = vendedorSelect
        this.produtos = produtoSelect
        this.linhas = linhaSelect
        this.clientes = clienteSelect
        this.segmento = selectSegmento

        this.updateDados()
      },

      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      updateDados () {
        eventEmit.$emit('update-form-mais-vida', this.dataInicial, this.dataFinal, this.select, this.cidades, this.areas, this.vendedores, this.redes, this.produtos, this.linhas, this.clientes, this.segmento)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
    },
  }
</script>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 560px) {

  }

  @media screen
  and (min-width : 481px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width: 1380px) {

  }
</style>

<style lang="sass">
  .highlighted-item
    background-color: #2863af
    padding: 16px
    color: white
    margin: -1rem 0 0 0

  #listItemVolumePreco
    margin: -2rem 0 0 -1rem

</style>
